/* eslint-disable max-len */
export const useCasesAreaMockedData = {
  "onLike": () => {},
  "onUnlike": () => {},
  "canUseLikeFeature": true,
  "itemId": 6085490,
  "useCases": [
    {
      "id": "29",
      "technology": "fdm",
      "printerType": {
        "name": "Prusa i3 MK3S",
        "hidden": false,
      },
      "slicesDetails": "case_setup.gcode",
      "description": "A custom 3D printed enclosure crafted for precision, stability, and optimal airflow. Designed for compact builds and extended print sessions, it combines clean aesthetics with efficient functionality. The modular design allows quick assembly and easy maintenance, making it ideal for hobbyists and professionals who value reliability, performance, and well-crafted design.",
      "status": "accepted",
      "itemId": 6085490,
      "createdAt": "2025-08-26T08:37:06.435Z",
      "updatedAt": "2025-08-26T08:37:06.435Z",
      "likeCount": 1,
      "username": "vladyslav-butenko",
      "userAvatar": "https://dynamic.heygen.ai/www/Avatars%20Page%20-%20Rebrand/Silvia.png?updatedAt=1757984236000",
      "liked": false,
      "isLoading": false,
      "useCaseEmbeds": [
        {
          "id": "83",
          "position": 1,
          "externalId": "",
          "source": "upload",
          "url": "https://cgtfiles.s3.amazonaws.com/uploads/use_case_embeds/83/file_example_MOV_1280_1_4MB.mov",
          "type": "video",
        },
        {
          "id": "84",
          "position": 2,
          "externalId": "",
          "source": "upload",
          "url": "https://cgtfiles.s3.amazonaws.com/uploads/use_case_embeds/84/style.png",
          "type": "image",
        },
        {
          "id": "85",
          "position": 3,
          "externalId": "",
          "source": "upload",
          "url": "https://cgtfiles.s3.amazonaws.com/uploads/use_case_embeds/85/A_House.png",
          "type": "image",
        },
        {
          "id": "86",
          "position": 4,
          "externalId": "",
          "source": "upload",
          "url": "https://cgtfiles.s3.amazonaws.com/uploads/use_case_embeds/86/Upscaled_Cake.jpg",
          "type": "image",
        },
        {
          "id": "87",
          "position": 5,
          "externalId": "cK98jx7gw7w",
          "source": "youtube",
          "url": "https://www.youtube.com/watch?v=cK98jx7gw7w",
          "type": "video",
        },
      ],
    },
    {
      "id": "30",
      "technology": null,
      "status": "accepted",
      "itemId": 6085490,
      "createdAt": "2025-08-26T08:37:56.908Z",
      "updatedAt": "2025-08-26T08:37:56.908Z",
      "likeCount": 0,
      "username": "vladyslav-butenko",
      "liked": false,
      "isLoading": false,
      "useCaseEmbeds": [
        {
          "id": "88",
          "position": 1,
          "externalId": "",
          "source": "upload",
          "url": "https://cgtfiles.s3.amazonaws.com/uploads/use_case_embeds/88/style.png",
          "type": "image",
        },
        {
          "id": "89",
          "position": 2,
          "externalId": "",
          "source": "upload",
          "url": "https://cgtfiles.s3.amazonaws.com/uploads/use_case_embeds/89/06fb927c-89f0-4f36-85ba-1235bfd84fd8.jpeg",
          "type": "image",
        },
        {
          "id": "90",
          "position": 3,
          "externalId": "",
          "source": "upload",
          "url": "https://cgtfiles.s3.amazonaws.com/uploads/use_case_embeds/90/My_Test_Image.jpg",
          "type": "image",
        },
        {
          "id": "91",
          "position": 4,
          "externalId": "",
          "source": "upload",
          "url": "https://cgtfiles.s3.amazonaws.com/uploads/use_case_embeds/91/struct.png",
          "type": "image",
        },
      ],
    },
  ],
  "role": "buyer",
  "itemUseCaseCount": 2,
}
